export default {

    AD_GROUP_URL: "https://13gazc26y7.execute-api.us-east-2.amazonaws.com/prod/token",
    SNAPSHOT_API: "https://7neu6v69dk.execute-api.us-east-2.amazonaws.com/prod/Snapshot/Request",
    STATE_CHANGE_API: "https://tqfit06ajg.execute-api.us-east-2.amazonaws.com/prod/Snapshot/StateChangeData",
    TenentURL: "https://login.microsoftonline.com/18a59a81-eea8-4c30-948a-d8824cdc2580",
    CALLBACK_URL: "https://d1rt2bm414tk50.cloudfront.net/auth/callback"
};